import { useEffect, useState } from 'react';
import type { LocationDistrict } from '@/lib/types';

type AllDistricts = Record<string, Record<string, LocationDistrict>>;

// constants/location_districts.ts is a 6,700+ line file computing ALL_DISTRICTS
// from a large embedded India district/sub-district dataset at module-load
// time — any static import of it (even just this one export) pulls the whole
// thing in, and it has no dependency-free way to import just a slice.
// The 5 filter components that need it (fuel/panchang/gold-silver/commodity
// location pickers) are unrelated to video and tag pages, but Next's
// automatic shared-chunk grouping was bundling this data into a chunk that
// video/tag pages also downloaded — confirmed via a real Playwright
// measurement showing ~3.2s to render a video page on a throttled mobile
// connection, largely spent downloading chunks these pages don't use.
// A dynamic import() here signals webpack to split this into its own
// on-demand chunk instead of the shared one, so pages that never render
// these filter components never pay for it.
export function useLazyAllDistricts(): AllDistricts | null {
  const [allDistricts, setAllDistricts] = useState<AllDistricts | null>(null);

  useEffect(() => {
    let cancelled = false;
    import('@/constants/location_districts').then((mod) => {
      if (!cancelled) setAllDistricts(mod.ALL_DISTRICTS);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return allDistricts;
}
